import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalService } from './global.service';
import { Observable } from 'rxjs';

@Injectable()
export class BackendService {
    url: string;
    systemUrl: string;
    apiKey: string;
    dependentDynamicPickCalls = {
        'getApplicationSetupForTerm': this.getApplicationSetupForTerm.bind(this)
    };

    constructor(private http: HttpClient,
                private globalService: GlobalService) {
        this.url = globalService.API_URL + 'api/v2/';
        this.systemUrl = globalService.API_URL;
        this.apiKey = globalService.API_KEY;
    }

    setCheck(params = '', resource: string): Observable<any> {
        return this.http.get(`${this.systemUrl}${resource}${params}`, {
            headers: this.setHeader()
        });
    }

    getAll(params = '', resource: string): Observable<any> {
        return this.http.get(`${this.url}${resource}${params}`, {
            headers: this.setHeader()
        });
    }

    getShortlink(params = '', resource: string): Observable<any> {
        return this.http.get(`${this.url}${resource}${params}`, {
            headers: this.setHeader(),
            responseType: 'text'
        });
    }

    getOne(id, resource: string): Observable<any> {
        return this.http.get(`${this.url}${resource}/${id}`, {
            headers: this.setHeader()
        });
    }

    create(resource: string, payload): Observable<any> {
        return this.http.post(`${this.url}${resource}`, payload, {
            headers: this.setHeader()
        });
    }

    createFeedback(resource: string, payload): Observable<any> {
        return this.http.put(`${this.url}${resource}`, payload, {
            headers: this.setHeader()
        });
    }

    sendFeedbackNotification(id, resource: string, suffix: string): Observable<any> {
        return this.http.put(`${this.url}${resource}/${id}/${suffix}`, {
            headers: this.setHeader()
        });
    }

    updateNested(id, resource: string, payload, suffix): Observable<any> {
        return this.http.put(`${this.url}${resource}/${id}/${suffix}`, payload, {
            headers: this.setHeader()
        });
    }

    update(id, resource: string, payload): Observable<any> {
        return this.http.put(`${this.url}${resource}/${id}`, payload, {
            headers: this.setHeader()
        });
    }

    deleteOne(id, resource: string): Observable<any> {
        return this.http.delete(`${this.url}${resource}/${id}`, {
            headers: this.setHeader()
        });
    }

    patchOne(id, resource: string, payload) {
        return this.http.patch(`${this.url}${resource}/${id}`, payload, {
            headers: this.setHeader()
        });
    }

    getDynamicPicks(callbackName, param) {
        return this.dependentDynamicPickCalls[callbackName](param);
    }

    getApplicationSetupForTerm(termID): Observable<any> {
        return this.http.get<any[]>(`${this.url}application-setups/pick-values?term=${termID}`, {
            headers: this.setHeader()
        });
    }

    updateOrder(id, resource: string, params, payload): Observable<any> {
        return this.http.put(`${this.url}${resource}/${id}/${params}`, payload, {});
    }

    getPicklistArray(className, fieldName): Observable<any[]> {
        return this.http.get<any[]>(`${this.url}picklists/${className}/${fieldName}`, {
            headers: this.setHeader()
        });
    }

    getStats(id, resource: string): Observable<any> {
        return this.http.get(`${this.url}${resource}/${id}/stats`, {
            headers: this.setHeader()
        });
    }

    setHeader() {
        return new HttpHeaders({
            'Authorization': this.apiKey,
            'x-requested-system-user' : 'students'
        })
    }

}
